<div
  class="progress-wrap"
  [ngClass]="{
    'on-background': isOnBackground,
    'exclusive-individual': individualExclusive,
    'exclusive-group': groupExclusive
  }">
  <svg #progress class="progress-svg" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"></svg>
</div>
